import React from "react";
import { JSX } from "react/jsx-runtime";

const BanUserIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10.8131 18H1.15394C0.767587 18 1.03609 11.625 2.79636 11.625C4.55663 11.625 8.63976 11.625 8.63976 11.625M10.2335 4.1875C10.2335 5.94791 8.80641 7.375 7.046 7.375C5.2856 7.375 3.8585 5.94791 3.8585 4.1875C3.8585 2.42709 5.2856 1 7.046 1C8.80641 1 10.2335 2.42709 10.2335 4.1875Z" stroke="#FF453A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.1283 15.8099L12.9338 10.3793M19.5449 12.9766C19.5449 15.3238 17.6421 17.2266 15.2949 17.2266C12.9477 17.2266 11.0449 15.3238 11.0449 12.9766C11.0449 10.6294 12.9477 8.72656 15.2949 8.72656C17.6421 8.72656 19.5449 10.6294 19.5449 12.9766Z" stroke="#FF453A" stroke-width="1.6" stroke-linecap="round"/>
    </svg>
  );
};

export default BanUserIcon;


